export default __webpack_public_path__ + "static/media/scooterPurple.cd26c90f.png";